import { keyframes } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const PartnerLogo = styled('img')(({ theme }) => ({
  margin: theme.spacing(0, 5),
  height: '41px',
}));

const slideKeyframe = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
`;

const Carousel = styled('div')(({ theme }) => ({
  borderTop: getBorder(theme.palette.border.default, 1, 'dashed'),
  borderBottom: getBorder(theme.palette.border.default, 1, 'dashed'),

  borderImage:
    'repeating-linear-gradient(90deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
  padding: theme.spacing(2, 0),
  overflow: 'hidden',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
}));

const Container = styled('div')(({ theme }) => ({
  display: 'inline-block',
  animation: `${slideKeyframe} 25s linear infinite`,
}));

export { PartnerLogo, Carousel, Container };
